import { useEffect } from 'react';
import { dispatchRemotePointer } from '../../services/pointer';

// Receives phone magic-pointer gestures relayed by the TV receiver page and
// replays them as real Pointer/Mouse/Wheel events inside this app.
const RemotePointerBridge = () => {
  useEffect(() => {
    const onMessage = (event) => {
      let fromParent = false;
      try {
        fromParent = window.parent && window.parent !== window && event.source === window.parent;
      } catch (err) {
        fromParent = false;
      }
      if (!fromParent) return;

      const data = event.data;
      if (!data || typeof data !== 'object') return;
      if (data.source !== 'flexwatch-remote' || data.type !== 'pointer') return;

      dispatchRemotePointer(data);
    };

    window.addEventListener('message', onMessage);
    return () => window.removeEventListener('message', onMessage);
  }, []);

  return null;
};

export default RemotePointerBridge;
